module.exports = __webpack_public_path__ + "img/edit.5229af71.svg";